<template>
  <v-sheet>
    <v-stepper id="step-top" v-model="step" fill-height class="">
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form
            class="cmd-form"
            ref="form"
            @submit.prevent="submitStep"
            lazy-validation
          >
            <v-container class="">
              <v-row justify="space-between">
                <v-col cols="12" sm="11" class="pt-0 pr-sm-8">
                  <h1 class="mb-5">{{ $t('identity.title') }}</h1>
                  <p class="mb-6">{{ $t('identity.text') }}</p>
                </v-col>
                <v-col cols="12" sm="6" class="pt-0">
                  <div class="form-field">
                    <label class="label-form">{{
                      $t('identity.numberLabel[0]')
                    }}</label>
                    <vue-tel-input
                      class="mobile-dropdown"
                      @validate="validate"
                      :defaultCountry="'PT'"
                      :autoDefaultCountry="false"
                      :autoFormat="false"
                      :validCharactersOnly="true"
                      :class="{
                        'vue-tel-input--has-focus': hasFocus,
                        'error-fields': errorMsg['mobileNumber'],
                      }"
                      @focus="hasFocus = true"
                      @blur="hasFocus = false"
                      @input="clearError('mobileNumber')"
                      :inputOptions="{
                        placeholder: $t('identity.numberLabel[1]'),
                      }"
                    ></vue-tel-input>
                    <p class="error-fields" v-if="errorMsg['mobileNumber']">
                      {{ $t('errors.' + errorMsg['mobileNumber']) }}
                    </p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 form-field">
                  <label class="label-form ">{{
                    $t('identity.pinLabel[0]')
                  }}</label>
                  <v-text-field
                    class="password-input"
                    :placeholder="$t('identity.pinLabel[1]')"
                    v-model="pin"
                    :class="{ 'error-fields': errorMsg['pin'] }"
                    flat
                    solo
                    inputmode="numeric"
                    type="password"
                    hide-details
                    @input="clearError('pin')"
                  ></v-text-field>
                  <p class="error-fields" v-if="errorMsg['pin']">
                    {{ $t('errors.' + errorMsg['pin']) }}
                  </p>
                </v-col>
                <v-col cols="12" class="mt-9">
                  <div class="link-inline mb-16 pb-4">
                    {{ $t('textNoCMD[0]') }}
                    <a
                      id="cmd-request"
                      target="_blank"
                      href="https://www.autenticacao.gov.pt/web/guest/cmd-assinatura#ativarassinatura"
                      @click.stop
                    >
                      {{ $t('textNoCMD[1]') }}
                      <img src="@/assets/link.svg" class="Shape" />.
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-footer fixed class="iframe-footer">
              <v-container grid-list-md text-center>
                <v-layout justify-end>
                  <v-btn
                    v-if="step != 0"
                    id="back"
                    @click="back"
                    class="back button-iframe"
                    >{{ $t('button.back') }}</v-btn
                  >
                  <v-btn
                    id="advance-btn"
                    :disabled="isDisabled"
                    :loading="isLoading"
                    depressed
                    type="submit"
                    class="advance button-iframe"
                    >{{ buttonText }}</v-btn
                  >
                </v-layout>
              </v-container>
            </v-footer>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-form
            class="cmd-form"
            ref="form-opt"
            @submit.prevent="submitStep"
            lazy-validation
          >
            <v-container>
              <v-row justify="space-between">
                <v-col cols="12" sm="10" class="pt-0 pr-6">
                  <h1 class="mb-5">{{ $t('authentication.title') }}</h1>
                  <p class="mb-6">{{ $t('authentication.text') }}</p>
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 form-field">
                  <label class="label-form mb-2">{{
                    $t('authentication.codeLabel[0]')
                  }}</label>
                  <v-text-field
                    class="password-input"
                    :placeholder="$t('authentication.codeLabel[1]')"
                    v-model="otpCode"
                    :class="{ 'error-fields': errorMsg['otpCode'] }"
                    flat
                    solo
                    inputmode="numeric"
                    type="password"
                    hide-details
                    @input="clearError('otpCode')"
                  ></v-text-field>
                  <p class="error-fields" v-if="errorMsg['otpCode']">
                    {{ $t('errors.' + errorMsg['otpCode']) }}
                  </p>
                </v-col>
              </v-row>
            </v-container>
            <v-footer fixed class="iframe-footer">
              <v-container grid-list-md text-center>
                <v-layout justify-end>
                  <v-btn
                    v-if="step != 0"
                    id="back"
                    @click="back"
                    class="back button-iframe"
                    >{{ $t('button.back') }}</v-btn
                  >
                  <v-btn
                    id="advance-btn"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    depressed
                    type="submit"
                    class="advance button-iframe"
                    >{{ buttonText }}</v-btn
                  >
                </v-layout>
              </v-container>
            </v-footer>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-sheet>
</template>

<script>
import { VueTelInput } from 'vue-tel-input';

import mixinQES from './mixinQES';

import {
  SEND_CMD_CREDENTIALS,
  VALIDATE_OPT,
} from '../../stores/modules/consts';

export default {
  name: 'SignatureProcess',
  mixins: [mixinQES],
  components: {
    VueTelInput,
  },
  watch: {
    mobileNumber(newValue) {
      if (newValue && newValue.length >= 9) {
        delete this.errorMsg['mobileNumber'];
        this.$forceUpdate();
      }
    },
    pin(newValue) {
      if (newValue && newValue.length >= 4) {
        delete this.errorMsg['pin'];
        this.$forceUpdate();
      }
    },
    otpCode(newValue) {
      if (newValue && newValue.length >= 6) {
        delete this.errorMsg['otpCode'];
        this.$forceUpdate();
      }
    },
  },
  methods: {
    clearError(error) {
      if (this.errorMsg[error]) {
        delete this.errorMsg[error];
      }
      delete this.errorMsg['expired'];

      this.hasErrors = Object.keys(this.errorMsg).length != 0;
    },
    validate(e) {
      if (e.valid) {
        this.mobileNumber = '+' + e.countryCallingCode + ' ' + e.nationalNumber;
      } else {
        this.mobileNumber = null;
      }
    },

    back() {
      console.log('Back Step', this.step);
      this.hasErrors = false;
      this.errorMsg = {};
      this.$store.commit('errorMsg');

      switch (this.step) {
        case 0:
          this.$router.push({ name: this.ROUTE_SIGNATURE_PROCESS });
          break;
        case 1:
          // console.log(this.BASE_ROUTE);
          this.$router.push({ name: this.BASE_ROUTE });

          break;
        case 2:
          // this.mobileNumber = null;
          this.otpCode = null;
          break;

        default:
          return this.$t('button.next');
      }
      this.step -= 1;
    },

    hideMobileKeyboard() {
      if (this.checkMobile()) {
        var body = document.getElementById('step-top');
        var field = document.createElement('input');

        field.setAttribute('type', 'text');
        body.appendChild(field);
        field.focus();
        body.removeChild(field);
      }
    },
    submitStep() {
      console.log('Submit Step', this.step);
      this.errorMsg = {};
      this.hasErrors = false;

      this.hideMobileKeyboard();

      if (this.checkFields()) {
        this.isLoading = true;
        this.snackbar = false;

        switch (this.step) {
          case 1:
            this.sendPinAndNumber();
            break;
          case 2:
            this.sendOTP();
            break;

          default:
            break;
        }
      }
    },
    async sendOTP() {
      // console.log('sendOTP');

      // GA Event
      this.$gtag.event('complete_qes', {
        event_category: 'qes',
        event_label: 'qes_complete_qes',
      });

      let res = await this.$store
        .dispatch(VALIDATE_OPT, {
          otpCode: this.otpCode,
          isEncrypted: this.isEncrypted,
        })
        .catch((errorMsg) => {
          const {
            event,
            event_category,
            event_label,
            type,
            message,
          } = errorMsg;

          if (type == 'banner') {
            this.$store.commit('errorMsg', message);
          } else {
            this.errorMsg[type] = message;
          }

          this.$gtag.event(event, {
            event_category,
            event_label,
          });
          this.$forceUpdate();
        });

      if (res) {
        // GA Event
        this.$gtag.event('success_qes', {
          event_category: 'qes',
          event_label: 'qes_success_qes',
        });
        this.$router.push(this.ROUTE_SUCCESS);
        //  this.step += 1;
      }

      this.isLoading = false;
    },
    async sendPinAndNumber() {
      // Check fields

      // GA Event
      this.$gtag.event('start_qes', {
        event_category: 'qes',
        event_label: 'qes_start_qes',
      });

      let res = await this.$store
        .dispatch(SEND_CMD_CREDENTIALS, {
          pin: this.pin,
          number: this.mobileNumber,
          isEncrypted: this.isEncrypted,
        })
        .catch((errorMsg) => {
          const {
            event,
            event_category,
            event_label,
            message,
            type,
          } = errorMsg;

          if (type == 'banner') {
            this.$store.commit('errorMsg', message);
          } else {
            this.errorMsg[type] = message;
          }

          this.$gtag.event(event, {
            event_category,
            event_label,
          });

          this.$forceUpdate();
        });

      if (res) {
        this.step = 2;
      }

      this.isLoading = false;
    },

    checkFields() {
      if (this.step == 1) {
        if (!this.mobileNumber) {
          this.errorMsg['mobileNumber'] = 'numberRequired';
        }

        if (!this.pin || this.pin.length < 4) {
          this.errorMsg['pin'] = 'pinRequired';
        }
      } else if (this.step == 2) {
        if (!this.otpCode || this.otpCode.length < 6) {
          this.errorMsg['otpCode'] = 'codeRequired';
        }
      }

      this.$forceUpdate();

      return Object.keys(this.errorMsg).length == 0;
    },
  },
  mounted() {
    // set step to 1 if page was reloaded
    this.step == 0 ? (this.step = 1) : this.step;
  },
  computed: {
    isDisabled() {
      return this.hasErrors; //Object.keys(this.errorMsg).length > 0;
    },
    buttonText() {
      switch (this.step) {
        case 0:
          return this.$t('button.next');
        case 1:
          return this.$t('button.authenticate');
        case 2:
          return this.$t('button.sign');
        default:
          return this.$t('button.next');
      }
    },
    step: {
      get() {
        return this.$store.state.qes.step;
      },
      set(newValue) {
        return this.$store.commit('qes/step', newValue);
      },
    },
  },
  data() {
    return {
      mobileNumber: null,
      pin: null,
      otpCode: null,
      errorMsg: {},
      hasErrors: false,
      hasFocus: false,
      isLoading: false,
      snackbar: false,
    };
  },
  created() {},
};
</script>
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
<style lang="scss">
.mobile-dropdown {
  &.vue-tel-input {
    border: solid 1px var(--light-grey);
    &--has-focus {
      border: solid 1px var(--teal-blue);
    }
    input,
    input::placeholder {
      margin: 5px 0;
      padding: 2px 0;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: var(--charcoal-grey);
    }
  }
}
</style>
